import { Link } from "react-router-dom";
import bcrnLogo from '../assets/image/bcrn-icon.svg';
import sipasiLogo from '../logo.svg';
import React from 'react';

// Definisikan objek gaya untuk kerapian
const styles: { [key: string]: React.CSSProperties } = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: '#f0f2f5',
        textAlign: 'center',
        padding: '20px',
        fontFamily: 'Arial, sans-serif'
    },
    logo: {
        height: '10em',
        padding: '1.5em',
        willChange: 'filter',
        transition: 'filter 300ms',
    },
    heading: {
        fontSize: '2.5rem',
        color: '#333',
        margin: '0.5em 0',
        lineHeight: '1.3'
    },
    button: {
        backgroundColor: '#007bff',
        color: 'white',
        border: 'none',
        borderRadius: '8px',
        padding: '12px 24px',
        fontSize: '1.1rem',
        fontWeight: 'bold',
        cursor: 'pointer',
        textDecoration: 'none',
        transition: 'background-color 0.3s ease',
        marginTop: '20px'
    },
    link: {
        textDecoration: 'none'
    }
};

export default function Home() {
    return (
        <div style={styles.container}>
            <div>
                {/* <a href="https://alanzulwas.my.id" target="_blank" rel="noopener noreferrer">
                    <img src={bcrnLogo} style={styles.logo} alt="Bacarina logo" />
                </a> */}
                <img src={sipasiLogo} style={styles.logo} alt="SiPasi logo" />
            </div>

            <h1 style={styles.heading}>
                {/* SiPasi <br />  */}
                Sistem Kepegawaian - Absensi <br /> Bawaslu Pohuwato
            </h1>
            
            <div>
                <Link to="/dashboard" style={styles.link}>
                    <button style={styles.button}>
                        Masuk
                    </button>
                </Link>
            </div>
        </div>
    );
}
  